import { Trans } from '@lingui/react'
import { type FC } from 'react'

import Price from 'views/components/atoms/Price'
import 'views/components/organisms/VolumePricingModal/VolumePricingModal.scss'
import { type RangesData } from 'views/components/organisms/VolumePricingModal/utils/volumePricingAccessor'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

type VolumePricingModalTableProps = {
  ranges: RangesData[]
}

const VolumePricingModalTable: FC<VolumePricingModalTableProps> = ({
  ranges,
}) => {
  const {
    publicRuntimeConfig: {
      publicConfig: { currency },
    },
  } = useShopAndRuntimeConfig()

  return (
    <>
      <h1 className="o-VolumePricingModalTable__heading">
        <Trans id="volumePricing.modal.heading" />
      </h1>
      <div className="o-VolumePricingModalTable">
        <table className="o-VolumePricingModal__table--content">
          <thead>
            <tr>
              <th className="rebranding o-VolumePricingModalTable__content--column">
                <Trans id="volumePricing.modal.table.quantity.label" />
              </th>
              <th className="rebranding o-VolumePricingModalTable__content--column">
                <Trans id="volumePricing.modal.table.savingPrice.label" />
              </th>
              <th className="rebranding o-VolumePricingModalTable__content--column ">
                <Trans id="volumePricing.modal.table.discount.label" />
              </th>
            </tr>
          </thead>
          <tbody>
            {ranges?.map((discount, index, discounts) => (
              <tr key={discount.id}>
                <td className="o-VolumePricingModalTable__content--discount range">
                  {discount.range}{' '}
                  <Trans
                    id="volumePricing.modal.table.pieces.label"
                    values={{ quantity: discount.range }}
                  />
                  {index === discounts.length - 1 && (
                    <>
                      {' '}
                      <Trans id="volumePricing.modal.table.morePieces.label" />
                    </>
                  )}
                </td>
                <td className="o-VolumePricingModalTable__content--discount price u-text-align--left">
                  <Price currency={currency} amount={discount.price} />
                </td>
                {discount.discountPercentage !== 0 && (
                  <td className="o-VolumePricingModalTable__content--discount-value">
                    {discount.discountPercentage}%
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default withShopAndRuntimeConfig(VolumePricingModalTable)
